import * as yup from 'yup';
import {
  closedCorpCompanyRegNumRegex,
  privateCompanyRegNumRegex,
  publicCompanyRegNumRegex,
  vatRegex
} from '../../../constants';

export const businessVerificationValidationSchema = yup.object().shape({
  businessName: yup
    .string()
    .when('$businessType', ([businessType], schema) =>
      businessType === 'Sole Proprietorship'
        ? schema.trim().min(1, 'Business Name must be at least 1 character long')
        : schema.trim().min(1, 'Business Name must be at least 1 character long').required('Business Name is required')
    ),

  regNumber: yup
    .string()
    .when('$businessType', ([businessType], schema) =>
      businessType !== 'Sole Proprietorship'
        ? schema
          .required('Business Registration Number is required')
          .test('valid-regNumber', 'Invalid Business Registration number format for the selected Business Type', (value) => {
            if (!value) {return false;}
            const regexMap = {
              'Private Company': privateCompanyRegNumRegex,
              'Close Corporation': closedCorpCompanyRegNumRegex,
              'Public Company': publicCompanyRegNumRegex
            };
            return regexMap[businessType]?.test(value) ?? true;
          })
        : schema
    ),

  vatNumber: yup
    .string()
    .when('$businessType', ([businessType], schema) =>
      businessType === 'Sole Proprietorship'
        ? schema.required('VAT Number is required')
          .matches(/^\d{9,12}$/, 'VAT Number must be between 9-12 digits')
          .matches(vatRegex, 'VAT Number must be a valid numerical value in the format 40xxx56789')
        : schema
    )
});